<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <div>
      <dk-editor
        class="dk-li"
        :content = "add.value.content"
        :content-update.sync = "add.value.content"/>
      <el-button
        class=""
        type="primary"
        @click="event().onSureClick()">保存</el-button>
    </div>
  </el-main>

</template>

<script>
import dkEditor from '../../components/quill-editor'
import { setExchangeRules, getExchangeRules } from '../../api/exchange'

export default {
  data() {
    return {
      add: {
        value: { content: '' },
      },
    };
  },
  created() {
    this.network().getExchangeRules()
  },
  methods: {
    event() {
      return {
        onSureClick: () => {
          this.network().setExchangeRules(this.add)
        },
      }
    },
    network() {
      return {
        setExchangeRules: async (add) => {
          if (!this.handler().verifyInput()) return
          const { status } = await setExchangeRules(add)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑兑换规则成功',
            type: 'success',
          });
          this.network().getExchangeRules()
        },
        getExchangeRules: async () => {
          const { status, data } = await getExchangeRules()
          if (status !== 200) return
          this.add = data
        },
      }
    },
    handler() {
      return {
        verifyInput: () => {
          if (!this.add.value.content) {
            this.$message({
              message: '请输入内容',
              type: 'warning',
            })
            return false
          }
          return true
        },
      }
    },
  },
  components: {
    dkEditor,
  },
};
</script>

<style scoped lang="scss">
.page-content-margin-unset{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/exchange/exchangeRules.vue